import { DestroyRef, inject } from '@angular/core';

// Lichte poll-timer voor "over-en-weer"-flows (bv. uitnodigen -> accepteren -> goedkeuren) waarbij
// de ene gebruiker moet zien dat de andere iets deed. Tikt elke intervalMs, maar roept reload()
// alleen aan als shouldPoll() op dat moment true is (er staat nog iets open) EN het tabblad
// zichtbaar is — voorkomt onnodig serververkeer vanuit verlaten/achtergrond-tabbladen of zodra er
// toch niets meer te verversen valt. Cleanup via DestroyRef, dus alleen aanroepen binnen een
// injection-context (component-constructor/veld-initializer).
export function pollWhilePending(shouldPoll: () => boolean, reload: () => void, intervalMs: number = 20000): void {
    const __destroyRef = inject(DestroyRef);

    const __timerId = setInterval(() => {
        if (!document.hidden && shouldPoll()) reload();
    }, intervalMs);

    __destroyRef.onDestroy(() => clearInterval(__timerId));
}
